import React, { useRef } from "react";
import Footer from "../components/Footer";

export default function AccountDeletion() {
    const footerRef = useRef(null);

    const accountDeletion = `Удаление аккаунта в приложении «Аквамаркет Тибетская»
Эта страница описывает, как удалить свой аккаунт и профиль в мобильном приложении «Аквамаркет Тибетская» (Android/iOS), а также какие данные при этом удаляются и какие сохраняются.

Как удалить аккаунт — пошаговая инструкция
 1. Откройте приложение «Аквамаркет Тибетская» и войдите в свой аккаунт по номеру телефона.
 2. В нижнем меню перейдите на вкладку «Профиль».
 3. Нажмите на пункт «Удалить аккаунт».
 4. В появившемся окне подтвердите действие, нажав «Удалить». Обратите внимание: это действие необратимо, восстановить аккаунт после подтверждения нельзя.
 5. После подтверждения доступ к аккаунту немедленно блокируется — повторный вход по этому номеру телефона станет невозможен.

Нет доступа к приложению или к номеру телефона, указанному при регистрации? Направьте запрос на удаление аккаунта на электронную почту info@tibetskaya.kz, указав номер телефона, привязанный к аккаунту. Мы обработаем такой запрос в разумный срок после подтверждения владения аккаунтом.

Какие данные удаляются
Немедленно после удаления аккаунта:
 • Доступ к аккаунту и возможность входа по номеру телефона.
 • Профильные данные: имя, номер телефона, адрес электронной почты, реферальный код.
 • Сохранённые адреса доставки.
 • Токен устройства для push-уведомлений — отправка уведомлений прекращается.
 • Привязка дальнейшей активности к рекламным и аналитическим идентификаторам (Adjust, Facebook) — новые события больше не связываются с удалённым аккаунтом.

Какие данные сохраняются и почему
 • История и содержание Заказов (состав, суммы, даты, статус доставки) — сохраняются в соответствии с требованиями законодательства Республики Казахстан о бухгалтерском и налоговом учёте, а также для рассмотрения возможных претензий и споров.
 • Сведения о произведённых платежах и пополнениях баланса (без данных банковской карты) — сохраняются для целей финансовой отчётности.
 • Переписка с поддержкой, связанная с оформленными заказами, — может сохраняться при необходимости разрешения спорной ситуации.
Указанные данные хранятся в течение срока, установленного законодательством Республики Казахстан для соответствующей категории документов, после чего подлежат удалению или обезличиванию.

Дополнительно
Подробный порядок обработки персональных данных описан в Политике конфиденциальности Приложения: www.tibetskaya.kz/privacyPolicy.
По вопросам, связанным с удалением аккаунта и обработкой персональных данных, обращайтесь: info@tibetskaya.kz, +7 727 3172737.
`

    const formattedPolicy = accountDeletion.split('\n').map((paragraph, index) => {
        if (paragraph.trim() === "") return null; // Пропускаем пустые строки
        return paragraph.startsWith(' ') ? <p key={index}>{paragraph.trim()}</p> : <h3 key={index}>{paragraph.trim()}</h3>;
    });

    return (
        <div className="flex flex-col min-h-screen justify-between">
            <div className="pt-5 px-5 space-y-3">
                <h2 className="text-lg font-bold">УДАЛЕНИЕ АККАУНТА</h2>
                {formattedPolicy}
            </div>

            <div className="">
                <Footer ref={footerRef} phone="+7 727 317 27 37" mail="info@tibetskaya.kz" />
            </div>
        </div>
    );
}
